import {FC} from 'react';
//mui
import {Box} from '@mui/material';
//components
import AuctionContent from './AuctionContent';
import RaffleContent from './RaffleContent';
import EventActions from '../EventActions';

const EventWebpage: FC = () => {
	return (
		<Box>
			<AuctionContent />
			<RaffleContent />
			<EventActions />
		</Box>
	);
};

export default EventWebpage;
